import { AHText, Box, useTheme, UserAvatar } from "arkh";
import { graphql, useFragment } from "react-relay";
import { OrgStoresMapActiveUsers_organisation$key } from "./__generated__/OrgStoresMapActiveUsers_organisation.graphql";
import { StyleSheet, View } from "react-native";
import Animated, { ZoomIn } from "react-native-reanimated";

export function OrgStoresMapActiveUsers(props: {
  organisation: OrgStoresMapActiveUsers_organisation$key;
}) {
  const data = useFragment(
    graphql`
      fragment OrgStoresMapActiveUsers_organisation on Organisation {
        recentlyActiveUsers {
          id
          user {
            name
            ...Avatar_user
          }
          store {
            name
          }
        }
      }
    `,
    props.organisation
  );

  const theme = useTheme();

  if (data.recentlyActiveUsers.length === 0) {
    return null;
  }

  return (
    <View style={styles.container}>
      {data.recentlyActiveUsers.map((entry, i) => (
        <Animated.View
          key={entry.id}
          entering={ZoomIn.duration(150).delay(i * 300)}
        >
          <Box color="surface" cornerRadius="medium" style={styles.card}>
            <UserAvatar user={entry.user} size="small" />
            <AHText
              type="subtitle"
              color="text-secondary"
              numberOfLines={1}
              style={styles.name}
            >
              {entry.user.name}
            </AHText>
            <AHText type="subtitle" numberOfLines={1}>
              {entry.store.name}
            </AHText>
            <View
              style={[
                styles.bullet,
                { backgroundColor: theme["status-positive"] },
              ]}
            />
          </Box>
        </Animated.View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 28,
    right: 12,
    gap: 8,
    zIndex: 1,
    maxWidth: 280,
  },
  card: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    gap: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 6,
    elevation: 3,
  },
  name: {
    flexShrink: 1,
  },
  bullet: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },
});
